<adf-sorting-picker
    [options]="options"
    [selected]="value"
    [ascending]="ascending"
    (valueChange)="onValueChanged($event)"
    (sortingChange)="onSortingChanged($event)">
</adf-sorting-picker>
